export const NOT_ALLOWED_FIELDS = ['termsconditions'];

export const GROUP_FIELD_TYPE_JSON = {
  products: {
    productimages: '',
    productcategory: '',
    productsubcategory: '',
    producttitle: '',
    productinfo: ''
  },
  coupons: {
    coupontitle: '',
    couponabout: '',
    couponecode: '',
    couponvalidtill: ''
  },
  deals: { dealtitle: '', dealabout: '', dealvalidtill: '' },
  image: {},
  video: {}
};

export const POPUP_MODAL_INIT = {
  state: false, // bool | manages open & close of modal
  type: '', // string | group type (product/deal/coupon/image/video/files)
  name: '', // string | field name
  index: null, // string | field index
  mode: '', // string | operation type => edit/add/delete | For files indicates what type of files to accept
  fields: null, // object | JSON fields for working form
  errorMessage: null // custom validation message
};

export const ALLOWED_FORM_LAYOUTS = {
  single: 'singlepage',
  section: 'sectionwise'
};

export const ALLOWED_FORM_PROFILE_IMAGE = {
  optional: 'optional',
  mandatory: 'mandatory',
  hide: 'hide'
};
